import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useLocation } from "react-router-dom";
import dataPolicy from "../../assets/footer/DATAPROTECTION.pdf";
import privacyNotice from "../../assets/footer/NOTIFICATIONPRIVACY.pdf";
import { Col, Container } from "react-bootstrap";
import imagenMarket from "../../assets/LOGO_MARKET_COLOMBINA.png";
import imagenBarraBlanca from "../../assets/BARA_VERTICAL.png";
export const Footer = () => {
  const path = useLocation().pathname;
  const donde = path.split("/")[1];
  const intl = useIntl();

  console.log(donde);
  return (
    <div>
      <div style={{}} className="footer">
        {intl.locale.includes("es") ? (
          <p>
            2023 ® Colombina S.A - Todos los derechos reservados -
            <a
              href="https://colombina.com//uploads/admin/media/upload/tratamiendo-de-datos/politica_proteccion_datos_personales_colombina_2020.pdf"
              className="linkPoliticas"
              target="_blank"
            >
              Politicas de Protección de datos personales.
            </a>
          </p>
        ) : (
          <p>
            2023 ® Colombina S.A - All rights reserved -
            <a
              href={
                [
                  "PUERTO_RICO",
                  "USA",
                  "JAMAICA",
                  "GUYANAS",
                  "SURINAM",
                  "TRINIDAD_TOBAGO",
                ].includes(donde)
                  ? dataPolicy
                  : "https://colombina.com//uploads/admin/media/upload/tratamiendo-de-datos/politica_proteccion_datos_personales_colombina_2020.pdf"
              }
              className="linkPoliticas"
              target="_blank"
            >
              Privacy Policy.
            </a>
            -
          </p>
        )}
      </div>
    </div>
  );
};
